"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const prop_types_1 = __importDefault(require("prop-types"));
const intl_1 = require("@kyruus/intl");
const button_1 = __importDefault(require("@kyruus/button"));
const styles_1 = require("./styles");
const messages_1 = __importDefault(require("../../lib/messages"));
function RecaptchaErrorModal({ onClose, onReset, intl }) {
    return (react_1.default.createElement(styles_1.Modal, { "data-testid": "RecaptchaErrorModal", title: intl.formatMessage(messages_1.default.interruptionapology), open: true, useHeaderBorder: false, maxWidth: "md", allowContentOverflow: true, body: react_1.default.createElement(intl_1.FormattedMessage, Object.assign({}, messages_1.default.recaptchaFailed)), onClose: onClose, primaryButton: react_1.default.createElement(button_1.default, { onClick: onReset, "data-testid": "RecaptchaErrorModalRetry" },
            react_1.default.createElement(intl_1.FormattedMessage, Object.assign({}, messages_1.default.retry))) }));
}
RecaptchaErrorModal.propTypes = {
    /** callback for when modal is closed */
    onClose: prop_types_1.default.func.isRequired,
    /** callback when user closes the modal to reset the captcha */
    onReset: prop_types_1.default.func.isRequired,
    // provided via `injectIntl`
    intl: prop_types_1.default.object.isRequired
};
exports.default = (0, intl_1.injectIntl)(RecaptchaErrorModal);
//# sourceMappingURL=RecaptchaErrorModal.js.map